// Auto generated file, do not manually modify!
// com.hotpads.adproducts.client.boost.enums.BoostAdFlagType

export enum BoostAdFlagType {
  BRAND_NEW = 'BRAND_NEW',
  CLOSE_TO_TRANSIT = 'CLOSE_TO_TRANSIT',
  CUSTOM = 'CUSTOM',
  DISABLED_HOUSING = 'DISABLED_HOUSING',
  GRAND_OPENING = 'GRAND_OPENING',
  INCOME_RESTRICTED = 'INCOME_RESTRICTED',
  MILITARY_HOUSING = 'MILITARY_HOUSING',
  NEWLY_RENOVATED = 'NEWLY_RENOVATED',
  NONE = 'NONE',
  PET_FRIENDLY = 'PET_FRIENDLY',
  SENIOR_LIVING = 'SENIOR_LIVING',
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  STUDENT_HOUSING = 'STUDENT_HOUSING',
}

export const BoostAdFlagType_values = [
  BoostAdFlagType.BRAND_NEW,
  BoostAdFlagType.CLOSE_TO_TRANSIT,
  BoostAdFlagType.CUSTOM,
  BoostAdFlagType.DISABLED_HOUSING,
  BoostAdFlagType.GRAND_OPENING,
  BoostAdFlagType.INCOME_RESTRICTED,
  BoostAdFlagType.MILITARY_HOUSING,
  BoostAdFlagType.NEWLY_RENOVATED,
  BoostAdFlagType.NONE,
  BoostAdFlagType.PET_FRIENDLY,
  BoostAdFlagType.SENIOR_LIVING,
  BoostAdFlagType.SPECIAL_OFFER,
  BoostAdFlagType.STUDENT_HOUSING,
] as const;
